/**
 * Constants for Spot Trading Modal
 * Centralized configuration values used across modal components
 */

/**
 * Fee and Tax Configuration
 * Used for calculating trading fees, GST, and TDS
 */
export const FEE_CONFIG = {
  COMMISSION_RATE: 0.1,
  GST_MULTIPLIER: 1.18,
  GST_PERCENT: 18,
  TDS_PERCENT: 1,
} as const;

/**
 * Slider/Range Selector Configuration
 * Used for percentage-based input controls
 */
export const SLIDER_CONFIG = {
  SNAP_LEVELS: [0, 25, 50, 75, 100],
  DEFAULT_MIN: 0,
  DEFAULT_MAX: 100,
  DEFAULT_STEP: 0.1,
  DEFAULT_TICKS: 5,
} as const;

/**
 * Symbol and Format Configuration
 */
export const SYMBOL_CONFIG = {
  TICKER_SUFFIX: '_INR',
  QUANTITY_PREFIX: 'Qty: ',
} as const;

/**
 * UI Configuration
 */
export const UI_CONFIG = {
  ASSET_ICON_SIZE: 24,
} as const;

/**
 * Order Status Types
 */
export const ORDER_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
} as const;

/**
 * Trade Modes
 */
export const TRADE_MODE = {
  BUY: 'buy',
  SELL: 'sell',
} as const;

/**
 * Transaction Status Types
 */
export const TRANSACTION_STATUS = {
  COMPLETED: 'completed',
  FAILED: 'failed',
  PENDING: 'pending',
} as const;

/**
 * Transaction/Transfer Types
 */
export const TRANSACTION_TYPE = {
  TRANSFER_IN: 'transfer-in',
  TRANSFER_OUT: 'transfer-out',
  WITHDRAW: 'withdraw',
} as const;

/**
 * Transfer History Tab Types
 */
export const TRANSFER_HISTORY_TAB = {
  ALL: 'all',
  TRANSFER_IN: 'transfer-in',
  TRANSFER_OUT: 'transfer-out',
} as const;

/**
 * Order Types
 */
export const ORDER_TYPE = {
  MARKET_ORDER: 'market_order',
} as const;

/**
 * Transaction Direction (for API)
 */
export const TRANSACTION_DIRECTION = {
  CREDIT: 'credited',
  DEBIT: 'debited',
} as const;

export const PRECISION_FOR_ASSETS = 6;
